"use strict";var merge=require("./merge-classes"),mixins=require("./transform-mixins");module.exports=function(e,r){var i=merge(e);return mixins(i,r)};


/*****************
 ** WEBPACK FOOTER
 ** ./~/reactcss/lib/combine.js
 ** module id = 886
 ** module chunks = 0
 **/